import { type QueryClient, useQuery } from '@tanstack/react-query';
import type { ParsedInsightsFilters } from '@/common/api/types/dashboard/filters';
import { useOrgId } from '@/common/hooks/useOrgId';
import { insightsQueryKeys } from '@/features/insights/queryKeys';
import { TrendsApi } from '@/features/insights-dashboard/api/trends';
import { INSIGHTS_STALE_TIME } from '@/features/insights-dashboard/components/data/constants';

export const invalidateTrendsProgress = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: insightsQueryKeys.trends.all() });
};

export const useTrendsProgress = ({
  filters,
  scopeItemId,
  loopId,
  dateRange,
  enabled = true,
}: {
  filters: ParsedInsightsFilters;
  scopeItemId?: number;
  loopId: number;
  dateRange?: { from: string; to: string };
  enabled?: boolean;
}) => {
  const orgId = useOrgId();

  return useQuery({
    queryKey: insightsQueryKeys.trends.progress({
      filters,
      scopeItemId,
      loopId,
      orgId,
      dateRange,
    }),
    queryFn: () => TrendsApi.getTrendsProgress({ filters, scopeItemId, loopId, dateRange }),
    enabled,
    staleTime: INSIGHTS_STALE_TIME,
    placeholderData: (previousData) => previousData,
    retry: false,
  });
};
